import { mq, PreviousIcon, theme, Title } from '@kvdbil/components';
import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.header`
  min-height: 2.25rem;
  background-color: ${theme.colors.background.gray};
  display: flex;
  align-items: center;
  padding: 0.75rem;
  border-bottom: 1px solid ${theme.colors.grayscaleToned.light3};

  ${mq(null, 'tablet')} {
    padding: 1rem;
  }

  svg {
    font-size: 1.5rem;
  }

  svg:first-child {
    margin-right: 0.5rem;
  }
`;

const Action = styled.div`
  margin-left: auto;
`;

interface Props {
  title?: string;
  icon?: ReactNode;
  action?: ReactNode;
  previewPageButtonHandler?: () => void;
}

const ItemHeader = ({
  previewPageButtonHandler,
  icon,
  title,
  action,
}: Props) => {
  const navigate = useNavigate();

  return (
    <Container>
      {icon ?? (
        <PreviousIcon
          width={'2rem'}
          height={'2rem'}
          onClick={() =>
            previewPageButtonHandler ? previewPageButtonHandler() : navigate(-1)
          }
        />
      )}
      <Title>{title}</Title>
      {action && <Action>{action}</Action>}
    </Container>
  );
};

export default ItemHeader;
